import { Button, ButtonProps } from 'ui';
import React from 'react';
import { useFormikContext } from 'formik';

interface Props extends Omit<ButtonProps, 'type'> {}

export const FormikSubmitButton: React.FC<Props> = ({
  children,
  disabled,
  ...props
}) => {
  const { isSubmitting } = useFormikContext();

  return (
    <Button {...props} type="submit" disabled={isSubmitting || disabled}>
      {children}
    </Button>
  );
};
